import { ChangeEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { CustomCheckBox } from "../../../shared/uiComponents";
import { useSelector } from "../../../redux/store";
import { SoapNotesStatuses } from "../../../redux/API/ClientAPIHelpers/dataCollectionProperties";
import { AdminTypes } from "../../../components/Menu";

const CalendarFilters = () => {
  const [params, setParams] = useSearchParams();
  const includeBTEvents =
    params.get("includeBTEvents") === "true" ? true : false;
  const includeBCBAEvents =
    params.get("includeBCBAEvents") === "true" ? true : false;

  const userId = useSelector((state) => state.account.user.id);
  const role = useSelector((state) => state.account.role);
  const events = useSelector((state) => state.calendar.events);
  const { client, therapist } = useSelector(
    (state) => state.calendar.filterData
  );

  const userSubmittedSessions = !!events?.length
    ? events?.filter(
      (x) =>
        x.isCompleted &&
        !!x.reportStatus &&
        x.reportStatus.status === SoapNotesStatuses.submitted &&
        x.user.id === userId
    ).length
    : 0;

  const userBTSubmittedSessions = !!events?.length
    ? events?.filter(
      (x) =>
        x.isCompleted &&
        !!x.reportStatus &&
        x.reportStatus.status === SoapNotesStatuses.submitted &&
        x.user.id !== userId &&
        x.user.role.section.id === AdminTypes.bt
    ).length
    : 0;

  const userBCBASubmittedSessions = !!events?.length
    ? events?.filter(
      (x) =>
        x.isCompleted &&
        !!x.reportStatus &&
        x.reportStatus.status === SoapNotesStatuses.submitted &&
        x.user.id !== userId &&
        x.user.role.section.id === AdminTypes.bcba
    ).length
    : 0;

  const userBTSessions = !!events?.length
    ? events?.filter((x) => x.user.id !== userId &&
      x.user.role.section.id === AdminTypes.bt).length
    : 0;

  const userBCBASessions = !!events?.length
    ? events?.filter((x) => x.user.id !== userId &&
      x.user.role.section.id === AdminTypes.bcba).length
    : 0;

  const drafts = !!events?.length
    ? events?.filter(
      (x) =>
        !!x.reportStatus && x.reportStatus.status === SoapNotesStatuses.draft
    ).length
    : 0;

  const completedSessions = !!userSubmittedSessions ?
    includeBCBAEvents && includeBTEvents ?
      `${userSubmittedSessions} - ${userBTSubmittedSessions} - ${userBCBASubmittedSessions}` :
      includeBTEvents ? `${userSubmittedSessions} - ${userBTSubmittedSessions}` :
        includeBCBAEvents ? `${userSubmittedSessions} - ${userBCBASubmittedSessions}` :
          userSubmittedSessions :
    0

  const labelCompleted = `Show Completed Sessions (${completedSessions})`;

  const labelBT = `Show BT Sessions ${!!userBTSessions ? `(${userBTSessions})` : ""
    }`;

  const labelBCBA = `Show BCBA Sessions ${!!userBCBASessions ? `(${userBCBASessions})` : ""
    }`;

  const labelDrafts = `Show Drafts ${!!drafts ? `(${drafts})` : ""}`;

  const showCompletedSessionHandler = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const { checked } = event.target;
    params.set("showCompleted", `${checked}`);
    setParams(params);
  };

  const showDraftsOnlyHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    params.set("showDraftsOnly", `${checked}`);
    setParams(params);
  };

  const showBTSessionsHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    params.set("includeBTEvents", `${checked}`);
    setParams(params);
  };

  const showBCBASessionsHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    params.set("includeBCBAEvents", `${checked}`);
    setParams(params);
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", width: '60%' }}>
      <CustomCheckBox
        item={{
          checked: params.get("showDraftsOnly") === "true",
          id: "3",
          label: labelDrafts,
        }}
        onChange={showDraftsOnlyHandler}
      />
      <CustomCheckBox
        item={{
          checked: params.get("showCompleted") === "true",
          id: "0",
          label: labelCompleted,
        }}
        onChange={showCompletedSessionHandler}
      />
      {!therapist?.id &&
        !client?.id &&
        !!role && (
          <>
            {
              role.section.id !== AdminTypes.bt && (
                <CustomCheckBox
                  item={{
                    checked: includeBTEvents,
                    id: "1",
                    label: labelBT,
                  }}
                  onChange={showBTSessionsHandler}
                />
              )
            }
            {
              role.section.id === AdminTypes.cs && (
                <CustomCheckBox
                  item={{
                    checked: includeBCBAEvents,
                    id: "2",
                    label: labelBCBA,
                  }}
                  onChange={showBCBASessionsHandler}
                />
              )
            }
          </>
        )
      }
    </div>
  );
};

export default CalendarFilters;
